import { useContext, useMemo } from 'react';
import { HubContext } from '../context/HubContext';

export const useHubContext = () => {
	const hubContext = useContext(HubContext);

	return hubContext;
};
